import { useContext } from 'react';
import ListingContext from '../../../contexts/ListingContext';
import { listingScores, totalScore, qualityRating, suggestion } from '../helpers/qualityScore';

export default function ListingQualityScore() {
  const {listing} = useContext(ListingContext);
  const scores = listingScores(listing);
  const score = totalScore(scores);
  return (
    <div className="listing-quality-rating">
      <div className={classnames("quality-donut", qualityRating(listing, score))}
        style={{"--listing-quality-score": score}}/>
      <div>
        <h5>Listing Quality</h5>
        <p>{suggestion(scores)}</p>
      </div>
    </div>
  );
}
